import { render, staticRenderFns } from "./ConsumeBox.vue?vue&type=template&id=62e7b3fa&scoped=true"
import script from "./ConsumeBox.vue?vue&type=script&lang=js"
export * from "./ConsumeBox.vue?vue&type=script&lang=js"
import style0 from "./ConsumeBox.vue?vue&type=style&index=0&id=62e7b3fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e7b3fa",
  null
  
)

export default component.exports